// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img.img-fluid[data-v-3e2f1450] {\n  max-width: 400px;\n  max-height: 400px;\n}", ""]);
// Exports
module.exports = exports;
